import Header from './components/Header';
import Hero from './components/Hero';
import IndexSection from './components/IndexSection';
import TopicsSection from './components/TopicsSection';
import ContactSection from './components/ContactSection';
import UpdatesSection from './components/UpdatesSection';
import FaqSection from './components/FaqSection';
import AboutSection from './components/AboutSection';
import FeaturesSection from './components/FeaturesSection';
import CarouselSection from './components/CarouselSection';
import CardsSection from './components/CardsSection';
import CommentsSection from './components/CommentsSection';
import RankingSection from './components/RankingSection';
import AppSection from './components/AppSection';
import MediaSection from './components/MediaSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <IndexSection />
        <TopicsSection />
        <ContactSection />
        <UpdatesSection />
        <FaqSection />
        <AboutSection />
        <FeaturesSection />
        <CarouselSection />
        <CardsSection />
        <CommentsSection />
        <RankingSection />
        <AppSection />
        <MediaSection />
      </main>
      <Footer />
    </div>
  );
}